var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.667 2c0-.92.746-1.667 1.666-1.667h13.334c.92 0 1.666.747 1.666 1.667v10c0 .92-.746 1.667-1.666 1.667H2.333c-.92 0-1.666-.746-1.666-1.667V2Zm2.932 0L9 6.726 14.401 2H3.6Zm12.068 1.107L9.549 8.461a.833.833 0 0 1-1.098 0L2.333 3.107V12h13.334V3.107Z",
    fill: "currentColor"
  })));
};
export default SvgEmail;